import { z } from "zod";

import {
  SubscriptionBillingProviderList,
  SubscriptionDtoSchema,
  SubscriptionIntervalList,
  SubscriptionWithScopesDtoSchema,
} from "./subscriptions";

export const SubscriptionStatusList = [
  "active",
  "pending",
  "cancelled",
] as const;
export type SubscriptionStatus = (typeof SubscriptionStatusList)[number];

export const OrganizationSubscriptionDtoSchema = z.object({
  id: z.string().uuid(),
  subscriptionId: z.string().uuid(),
  organizationId: z.string().uuid(),
  subscriptionPriceUsd: z.number(),
  subscriptionStatus: z.enum(SubscriptionStatusList),
  subscriptionInterval: z.enum(SubscriptionIntervalList),
  intervalCount: z.number().default(1),
  subscription: SubscriptionWithScopesDtoSchema,
  billingProvider: z.enum(SubscriptionBillingProviderList),
});

export type OrganizationSubscriptionDto = z.infer<
  typeof OrganizationSubscriptionDtoSchema
>;
